module.exports = __webpack_public_path__ + "static/media/2DGACM1.9aa5d3e5.jpg";